module.exports = __webpack_public_path__ + "media/auto_main_information/ubezpieczenie-komunikacyjne-3448ac55.svg";